export const ButtonLinkVariants = {
    primary: 'primary',
    secondary: 'secondary',
};

export const ButtonLinkSize = {
    large: 'large-button',
    regular: 'regular-button',
};
